module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fb-Ga-Hc-Ia.95d5567d.png";